//hook
import { UserConsumer } from "../hooks/context/UserContext";

interface timeAndHourBookingProps {
  title: string;
  value: any;
  icon?: React.ReactNode;
  type?: string
}

const TimeAndHourBooking = ({ title, value, icon, type}: timeAndHourBookingProps) => {
    let {theme} = UserConsumer()
    return (
      <div className="flex items-start gap-2">
          <div>
              <p className={`${type === "electric" ? "!text-electricColor": theme === "client" ? "!text-customerColor" : "!text-paretnerColor"}`}>{icon}</p>
          </div>
          <div>
              <p className="max-sm:text-[11px]">{title}</p>
              <p className="text-[13px] max-sm:text-[11px] font-[700]">{value}</p>
          </div>
      </div>
  )
}

export default TimeAndHourBooking